import {
    DEFAULT_LANGUAGE,
    FIREBASE_CONFIG,
    RECAPTCHA_CONTAINER_ID,
} from '@/constants';
import { FirebaseError, initializeApp } from 'firebase/app';
import {
    getAuth,
    signInWithPopup,
    GoogleAuthProvider,
    createUserWithEmailAndPassword,
    signInWithEmailAndPassword,
    sendPasswordResetEmail,
    RecaptchaVerifier,
    multiFactor,
    PhoneAuthProvider,
    getMultiFactorResolver,
    MultiFactorError,
    OAuthProvider,
    fetchSignInMethodsForEmail,
} from 'firebase/auth';

export const app = initializeApp(FIREBASE_CONFIG);

export const firebaseAuth = getAuth(app);

// firebaseAuth.languageCode = 'en';
firebaseAuth.useDeviceLanguage();

const MsfProvider = new OAuthProvider('microsoft.com');
MsfProvider.setDefaultLanguage(DEFAULT_LANGUAGE);
MsfProvider.setCustomParameters({
    prompt: 'select_account',
});
export const signInWithMsfPopUp = async () => {
    try {
        const result = await signInWithPopup(firebaseAuth, MsfProvider);
        return result;
    } catch (error) {
        if (
            error instanceof FirebaseError &&
            error.code === 'auth/account-exists-with-different-credential'
        ) {
            const credential = OAuthProvider.credentialFromError(error);

            const email = error?.customData?.email as string;

            const signInMethods = await fetchSignInMethodsForEmail(
                firebaseAuth,
                email
            );

            if (
                signInMethods.length === 1 &&
                signInMethods[0] === 'password' &&
                credential
            ) {
                //@ts-ignore
                window.MSF_FIREBASE_CREDENTIAL = credential;
                alert(
                    'Please first sign is with user and password in order to enable your Microsoft account.'
                );
            }
        }
        throw error;
    }
};

const googleProvider = new GoogleAuthProvider();
googleProvider.addScope('profile');
googleProvider.addScope('email');
googleProvider.setDefaultLanguage(DEFAULT_LANGUAGE);
googleProvider.setCustomParameters({ prompt: 'select_account' });
// googleProvider.setDefaultLanguage('fr');
export const signInWithGoogle = () =>
    signInWithPopup(firebaseAuth, googleProvider);

export const createFirebaseUser = (email: string, password: string) => {
    return createUserWithEmailAndPassword(firebaseAuth, email, password);
};

export const loginFirebaseUser = (email: string, password: string) => {
    return signInWithEmailAndPassword(firebaseAuth, email, password);
};

export const sendFbPasswordResetEmail = (email: string) => {
    return sendPasswordResetEmail(firebaseAuth, email);
};

export const isPasswordUser = () => {
    return (
        firebaseAuth.currentUser?.providerData.length === 1 &&
        firebaseAuth.currentUser?.providerData[0].providerId === 'password'
    );
};

export const hasPasswordProvider = () => {
    return firebaseAuth.currentUser?.providerData.some(
        (provider) => provider.providerId === 'password'
    );
};

export const isFbEmailVerified = () => {
    return firebaseAuth.currentUser?.emailVerified ?? false;
};

export const getCurrentUser = async () => {
    if (!firebaseAuth.currentUser) throw new Error('No current user');
    await firebaseAuth.currentUser.reload();
    return firebaseAuth.currentUser;
};

export const getRecaptchaVerifier = () =>
    new RecaptchaVerifier(firebaseAuth, RECAPTCHA_CONTAINER_ID, {
        size: 'invisible',
        badge: 'inline',
    });

export const getMultiFactor = async () => {
    const currentUser = await getCurrentUser();
    return multiFactor(currentUser);
};

export const getMultiFactorSession = async () => {
    const multiFactor = await getMultiFactor();
    return multiFactor.getSession();
};

export const getPhoneAuthProvider = () => new PhoneAuthProvider(firebaseAuth);

export const getMultiFactorReslv = (error: MultiFactorError) =>
    getMultiFactorResolver(firebaseAuth, error);
